// extracted by mini-css-extract-plugin
export default {"starIcon":"FeaturedTag-starIcon-4331d477a00ccb671be8f99a907f6c69"};